import { apiClient } from '@/lib/api';

export interface ElectrodeTypeDto {
  id: string;
  name: string;
  manufacturer: string;
  channelCount: number;
  version: string;
  isActive: boolean;
}

export const electrodeTypeService = {
  /**
   * Get all active electrode types
   * GET /api/v1/ElectrodeTypes
   */
  async getElectrodeTypes(channelCount?: number): Promise<ElectrodeTypeDto[]> {
    const params = channelCount ? { channelCount } : {};
    const response = await apiClient.get<{ items: ElectrodeTypeDto[] }>('/api/v1/ElectrodeTypes', { params });
    return response.data.items;
  },

  /**
   * Get electrode type by ID
   * GET /api/v1/ElectrodeTypes/{id}
   */
  async getElectrodeTypeById(id: string): Promise<ElectrodeTypeDto> {
    const response = await apiClient.get<ElectrodeTypeDto>(`/api/v1/ElectrodeTypes/${id}`);
    return response.data;
  },
};
